import { WRITE_ATTEMPT_STORAGE_PREFIX } from "@/lib/writeAttempt";

const KEYS_TO_KEEP = ["i18nextLng", "theme"];

export async function clearClientAuthState(): Promise<void> {
  Object.keys(localStorage).forEach((key) => {
    if (!KEYS_TO_KEEP.includes(key)) {
      localStorage.removeItem(key);
    }
  });

  Object.keys(sessionStorage).forEach((key) => {
    if (!key.startsWith(WRITE_ATTEMPT_STORAGE_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  });
}
